"use client";

import React, { useEffect, useState } from "react";
import { InfiniteMovingCards } from "../ui/infinite-moving-cards";

const t1 = [
  {"id":1, "name": "HTML", "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/HTML5_logo_and_wordmark.svg/768px-HTML5_logo_and_wordmark.svg.png"},
  {"id":2, "name": "CSS", "url": "https://cdn.worldvectorlogo.com/logos/css-3.svg"},
  {"id":3, "name": "JavaScript", "url": "https://cdn.worldvectorlogo.com/logos/javascript-1.svg"},
  {"id":4,"name": "TypeScript","url": "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/768px-Typescript_logo_2020.svg.png?20221110153201"},
  { "id": 5, "name": "React", "url": "https://cdn.worldvectorlogo.com/logos/react-2.svg" },
  { "id": 6, "name": "Next.js", "url": "https://img.icons8.com/?size=100&id=yUdJlcKanVbh&format=png&color=000000" },
  { "id": 7, "name": "Vue.js", "url": "https://vuejs.org/images/logo.png" },
  { "id": 8, "name": "Quasar", "url": "https://cdn.quasar.dev/logo/svg/quasar-logo.svg" },
  { "id": 9, "name": "React Three Fiber", "url": "https://raw.githubusercontent.com/pmndrs/react-three-fiber/449b7f4effed3055d3fbba858c818d4747ac2ac6/example/favicon.svg" },
  { "id": 10, "name": "React Native", "url": "https://cdn.worldvectorlogo.com/logos/react-native-1.svg" },
  { "id": 11, "name": "Framer Motion", "url": "https://framerusercontent.com/images/0MHMgyzBybzn2UuLltHc7lcsOIc.png" },
  { "id": 12, "name": "Electron", "url": "https://www.electronjs.org/assets/img/logo.svg" },
  { "id": 13, "name": "Node.js", "url": "https://nodejs.org/static/images/logo.svg" },
  { "id": 14, "name": "Tailwind CSS", "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/330px-Tailwind_CSS_Logo.svg.png" },
  { "id": 15, "name": "Express", "url": "https://expressjs.com/images/favicon.png" },
  { "id": 38, "name": "Swift", "url": "https://cdn.worldvectorlogo.com/logos/swift-15.svg" },
  { "id": 39, "name": "Kotlin", "url": "https://upload.wikimedia.org/wikipedia/commons/7/74/Kotlin_Icon.svg" },
]
const t2 = [{ "id": 16, "name": "Vitest", "url": "https://vitest.dev/logo.svg" },
  { "id": 17, "name": "Playwright", "url": "https://playwright.dev/img/playwright-logo.svg" },
  { "id": 18, "name": "Zustand", "url": "https://raw.githubusercontent.com/pmndrs/zustand/main/docs/favicon.ico" },
  { "id": 19, "name": "Redux", "url": "https://redux.js.org/img/redux-logo-landscape.png" },
  { "id": 20, "name": "TanStack", "url": "https://tanstack.com/images/logos/splash-light.png" },
  { "id": 21, "name": "React Router DOM", "url": "https://reactrouter.com/favicon.ico" },
  { "id": 22, "name": "React Navigation", "url": "https://reactnavigation.org/img/spiro.svg" },
  { "id": 23, "name": "Mapbox", "url": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Mapbox_logo_2017.svg/330px-Mapbox_logo_2017.svg.png" },
  { "id": 24, "name": "Firebase", "url": "https://firebase.google.com/static/images/favicon.png" },
  { "id": 25, "name": "Jest", "url": "https://jestjs.io/img/jest.png" },
  { "id": 26, "name": "React Testing Library", "url": "https://testing-library.com/img/octopus-64x64.png" },
  { "id": 27, "name": "GraphQL", "url": "https://graphql.org/img/logo.svg" },
  { "id": 28, "name": "urql", "url": "https://raw.githubusercontent.com/urql-graphql/urql/main/packages/site/src/assets/sidebar-badge.svg" }]
const t3 = [
  { "id": 29, "name": "Git", "url": "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png" },
  { "id": 30, "name": "Docker", "url": "https://www.docker.com/wp-content/uploads/2022/03/Moby-logo.png" },
  { "id": 31, "name": "Google Cloud Platform", "url": "https://image.similarpng.com/very-thumbnail/2020/06/Logo-google-cloud-icon-vector-PNG.png" },
  { "id": 32, "name": "MongoDB", "url": "https://www.mongodb.com/assets/images/global/favicon.ico" },
  { "id": 33, "name": "PWA", "url": "https://user-images.githubusercontent.com/3104648/28351989-7f68389e-6c4b-11e7-9bf2-e9fcd4977e7a.png" },
  { "id": 34, "name": "WebSockets", "url": "https://socket.io/images/logo-dark.svg" },
  { "id": 35, "name": "LLMs", "url": "https://seeklogo.com/images/M/microsoft-365-copilot-logo-44BA459F18-seeklogo.com.png" },
  { "id": 40, "name": "Agentic Coding", "url": "https://mintlify.s3.us-west-1.amazonaws.com/cursor/logo/dark.svg" },
  { "id": 36, "name": "VS Code", "url": "https://code.visualstudio.com/favicon.ico" },
  { "id": 37, "name": "Figma", "url": "https://cdn.sanity.io/images/599r6htc/regionalized/46a76c802176eb17b04e12108de7e7e0f3736dc6-1024x1024.png?w=804&q=75&fit=max&auto=format&dpr=2" }
];

export default function Skills() {
  return (
    <div className="pt-10 rounded-md flex flex-col space-y-2 antialiased bg-black bg-grid-white/[0.05] items-center justify-center relative overflow-hidden">
      <InfiniteMovingCards
        items={t1}
        direction="right"
      />
      <InfiniteMovingCards
        items={t2}
        direction="left"
      />
      <div className="md:hidden"><InfiniteMovingCards
        items={t3}
        direction="right"
      /></div>
    </div>
  );
}

